import { HttpClient } from '@angular/common/http';
import { Injectable, EventEmitter } from '@angular/core';
import { Observable, of, pipe } from 'rxjs';

import { ApiGatewayHelperService }from './apigateway-helper.service';
import { LoaderService } from './loader.service';

import Raven from 'raven-js';
import { map } from 'rxjs/operators';
import { appSetting } from 'config/appSettings';
import { ThemeService } from "libs-frontend-micro-base";
import { GigyaSessionService } from './gigya-session.service';
import { CacheService } from './cache.service';
import { config } from 'config';
@Injectable()
export class AuthService {
    private userData;
    isUserAuthenticationChecked = false;
    themeService;
    logoutTriggered = new EventEmitter<string>();
    userAuthenticatedDataSource: string;
    isGigyaLoaded = false;
    rurl : string;
    constructor(
        private http: HttpClient,
        private apiGatewayHelperService : ApiGatewayHelperService,
        private loaderService: LoaderService,
        private gigyaSessionService: GigyaSessionService,
        private cacheService: CacheService
    ) { 
        this.themeService = new ThemeService();
    }

    logOut() : Observable<any> {
        Raven.setUserContext();
        this.loaderService.showOverlayLoader();
        return this.http.post(this.apiGatewayHelperService.getApiGatewayPrefixUrl() + 'logout', {}).pipe(
            map((res: any) => {
                // Remove existing user data in Session Storage
                sessionStorage.removeItem(appSetting.sessionStorage.userAccount);
                if (res.success) {
                    setTimeout(() => { localStorage.setItem(appSetting.localStorage.userLoggedOut, 'true'); }, 500);
                }
                this.themeService.resetThemeToDefault();
                this.logoutTriggered.emit('');
                return res;
            })
        );
    }

    loginWithExistingGigyaSession(loggedInUserData) : Observable<any> {
        return this.http.post(this.apiGatewayHelperService.getApiGatewayPrefixUrl() + 'login', loggedInUserData);
    }

    isUserAuthenticated() {
        const userData = sessionStorage.getItem(appSetting.sessionStorage.userAccount);
        if(userData) {
            this.userAuthenticatedDataSource = 'sessionStorage';
            return of({
                userAuthenticated: true,
                user: JSON.parse(userData)
            });
        } else {
            return this.http.get(this.apiGatewayHelperService.getApiGatewayPrefixUrl() + 'isUserAuthenticated');
        }
    }
    setUserData(user) {
        this.userData = user;
    }
    getUserData() {
        // isDesktopApp check commented to resolve 
        // NEMO-3874: Linux User Data sharing
        // part of fix has been applied in launch-page.component also
        // setUserData has been called from there to save user info when user logs in desktop app
        /* if(environment.isDesktopApp){
            return { extUserId : "teacher1234" }
        } */
        return this.userData;
    }
    // cleans userData
    clearUserdata(){
        this.isUserAuthenticationChecked = false;
        this.userData = false;
    }
    checkGigyaAndServerSession(){
        //Both guard and app.component are calling this function and setting 1 variable each in this service
        //When both variables are true then logoutGigyaOrExpressServer function is called to check both sessions. 
        return new Promise(async(resolve, reject)=> {
            //Check the server session and gigya session only if gigya is loaded and user authentication is checked
            if(this.isUserAuthenticationChecked && this.isGigyaLoaded) {
                const gigyaData = await this.gigyaSessionService.getUserData()
                this.logoutGigyaOrExpressServer(gigyaData, this.userData);
                resolve(true);
            } else { //Continue the calling function if any of gigya or server session is not yet loaded/checked 
                resolve(true);
            }
        })

    }

    async getUserDataFromSession() {
        if(!this.isUserAuthenticationChecked) {
            const res:any = await this.isUserAuthenticated().toPromise();
            this.isUserAuthenticationChecked = true;
            if(res.userAuthenticated) {
                this.setUserData(res.user);
                sessionStorage.setItem(appSetting.sessionStorage.userAccount, JSON.stringify(res.user));
            }
        }
        return this.getUserData();
    }
    private logoutGigyaOrExpressServer(gigyaSessionExists, serverSessionExists) {
        if (gigyaSessionExists && serverSessionExists) {
            if(gigyaSessionExists.UID == serverSessionExists.extUserId) return true;
            else {
                this.logOut().toPromise().then(() => {
                    return this.gigyaSessionService.gigyaLogout();                  
                }).then(()=> {
                    this.navigateToRurl();
                });
            }

        } else if (!gigyaSessionExists && serverSessionExists) {
            //end backend session and navigate to home page
            this.logOut().toPromise().then(() => {
                // On Logout navigate to home page
                this.navigateToRurl();

            });
        } else if (gigyaSessionExists && !serverSessionExists) {
            /**
            * This is to handle the case when user is logged out from backend but gigya session still exists
            */

            this.gigyaSessionService.getUserData().then((userData) => {
                this.loginWithExistingGigyaSession(userData).toPromise().then((res) => {
                    return true;
                });
            });
        } else {
            this.navigateToRurl();
        }
    }

    navigateToRurl() {
        //Navigate to Home if user is unauthenticated
        if(this.rurl) {
            this.navigateToOnboardingApp(['login'], { queryParams : { rurl : encodeURIComponent(this.rurl)}});
        } else {
            this.navigateToOnboardingApp(['login']);
        }
    }

    navigateToOnboardingApp(urlArray, options?) {
        this.loaderService.showOverlayLoader();
        if (options && options.queryParams && Object.keys(options.queryParams).length > 0) {
            window.location.href = config.onBoardingAppDomain + urlArray.join('/') + '?' + Object.keys(options.queryParams).map(key => `${key}=${options.queryParams[key]}`).join('&');
        } else {
            window.location.href = config.onBoardingAppDomain + urlArray.join('/');
        }
    }
}